import { Section, Question, DropdownItem } from './formData.types';
import {
  FORM_SECTION_IDS,
  FORM_PREFIXES,
  QUESTION_ID_PREFIXES,
} from './formSectionConstants';

export const findSectionById = (
  sections: Section[],
  sectionId: string
): Section | undefined => {
  return sections.find((section: Section) => section.SECTION_ID === sectionId);
};

export const getDropdownSections = (sections: Section[]) => {
  return {
    txMonitoringDropdowns: findSectionById(
      sections,
      FORM_SECTION_IDS.TX_MONITORING_DROPDOWNS
    ),
    d2MonitoringDropdowns: findSectionById(
      sections,
      FORM_SECTION_IDS.D2_MONITORING_DROPDOWNS
    ),
  };
};

export const removeMonitoringPrefix = (type: string): string => {
  const lowerType = type.toLowerCase();

  if (lowerType.includes(FORM_PREFIXES.TX_MONITORING)) {
    return lowerType.replace(FORM_PREFIXES.TX_MONITORING, '');
  } else if (lowerType.includes(FORM_PREFIXES.D2_MONITORING)) {
    return lowerType.replace(FORM_PREFIXES.D2_MONITORING, '');
  }

  return lowerType;
};

export const createDropdownItemsFromQuestions = (
  questions: Question[]
): DropdownItem[] => {
  return questions.map((question: Question) => ({
    type: removeMonitoringPrefix(question.QUESTION_ID),
    placeholder: question.QUESTION_TEXT,
    options: question.QUESTION_OPTIONS || [],
    selected: undefined,
  }));
};

export const processAllDropdownSections = (
  sections: Section[]
): DropdownItem[] => {
  const { txMonitoringDropdowns, d2MonitoringDropdowns } =
    getDropdownSections(sections);
  let defaultDropdownItems: DropdownItem[] = [];

  if (txMonitoringDropdowns?.QUESTIONS) {
    const txItems = createDropdownItemsFromQuestions(
      txMonitoringDropdowns.QUESTIONS
    );
    defaultDropdownItems = [...defaultDropdownItems, ...txItems];
  }

  if (d2MonitoringDropdowns?.QUESTIONS) {
    const d2Items = createDropdownItemsFromQuestions(
      d2MonitoringDropdowns.QUESTIONS
    );
    defaultDropdownItems = [...defaultDropdownItems, ...d2Items];
  }

  return defaultDropdownItems;
};

export const findQuestionAcrossSections = (
  sections: Section[],
  itemType: string
): Question | undefined => {
  const upperType = itemType.toUpperCase();
  const { txMonitoringDropdowns, d2MonitoringDropdowns } =
    getDropdownSections(sections);

  if (txMonitoringDropdowns) {
    let question = txMonitoringDropdowns.QUESTIONS.find(
      (q: Question) =>
        q.QUESTION_ID === `${QUESTION_ID_PREFIXES.TX_MONITORING}${upperType}`
    );
    if (question) return question;

    question = txMonitoringDropdowns.QUESTIONS.find(
      (q: Question) =>
        q.QUESTION_ID === `${QUESTION_ID_PREFIXES.D2_MONITORING}${upperType}`
    );
    if (question) return question;
  }

  if (d2MonitoringDropdowns) {
    const question = d2MonitoringDropdowns.QUESTIONS.find(
      (q: Question) =>
        q.QUESTION_ID === `${QUESTION_ID_PREFIXES.D2_MONITORING}${upperType}`
    );
    if (question) return question;
  }

  return undefined;
};

export const getSectionsByType = (
  sections: Section[],
  type: string
): Section[] => {
  return sections.filter((section: Section) => section.TYPE === type);
};

export const getBulletPointSections = (sections: Section[]): Section[] => {
  return getSectionsByType(sections, FORM_SECTION_IDS.BULLET_POINT);
};
